"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGridRerender = void 0;
const react_1 = require("react");
const adapter_1 = require("@video/video-client-core/lib/api/adapter");
const context_1 = require("../../context");
const useRefDimensions_1 = require("./useRefDimensions");
// I think this should be refactored to be put in the store
const useGridRerender = () => {
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    const [render, reRender] = (0, react_1.useState)(false);
    const { width, height } = (0, useRefDimensions_1.useRefDimensions)(ctx === null || ctx === void 0 ? void 0 : ctx.playersWrapperElement);
    (0, react_1.useEffect)(() => {
        const updateReRender = () => {
            reRender((prev) => !prev);
        };
        adapter_1.device.addEventListener("resize", updateReRender);
        updateReRender();
        return () => adapter_1.device.removeEventListener("resize", updateReRender);
    }, [width, height]);
    return render;
};
exports.useGridRerender = useGridRerender;
//# sourceMappingURL=useGridRerender.js.map